import ActionsContainer from "../../../Pages/EditProduct/Components/ActionsContainer";
import Button from "@material-ui/core/Button";
import ToolbarContainer from "../../../Pages/EditProduct/Components/ToolbarContainer";
import React, {useMemo, useState} from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import AppBar from "./AppBar";
import useTemplateInstance from "../../../hooks/useTemplateInstance";
import {
    ACTIONS,
    getPartRefById,
    getUserImageResourcesByPartRef,
    getUserTextResourcesByPartRef,
    templateIsComplete
} from "../../../../Providers/TemplateInstanceProvider";
import {Trans, useTranslation} from "react-i18next";
import TemplatePageList from "./TemplatePageList";
import Icon from "@material-ui/core/Icon";
import ToolbarContent from "../../../Pages/EditProduct/Components/ToolbarContent";
import {Bubble, BubbleList} from "./Bubble";
import TemplateContainer from "./TemplateContainer";
import PreviewDialog from "./PreviewDialog";
import {useHistory} from "react-router";
import ExitDialog from "../../../Pages/EditProduct/Components/ExitDialog";

const useStyles = makeStyles(theme => ({
    mainContainer: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    }
}))

const MainPage = ({templateInstance, changeMenu, mode, updateCart}) => {
    const classes = useStyles();
    const [state, dispatch] = useTemplateInstance()
    const [t] = useTranslation();
    const [previewMode, setPreviewMode] = useState(false);
    const history = useHistory();
    const [showSaveChangesDialog, setShowSaveChangesDialog] = useState(false)

    const textResources = useMemo(() => {
        const partRef = getPartRefById(state.currentPartRefId, state.template)
        return getUserTextResourcesByPartRef(partRef, state);
    }, [templateInstance])

    const isComplete = useMemo(() => {
        return templateIsComplete(state);
    }, [state]);

    const addToCart = () => {
        //const resourceList = getUserResourcesAsList(state);
        //console.log('Resource list', resourceList);
        // Check if we're done...

        changeMenu('buy');
    }

    const handleUpdateCart = () => {
        const resources = Object.values(state.resources).filter(resource => resource.userSupplied);
        updateCart(resources, state.year);
    }

    const onSelectImage = () => {
        const partRef = getPartRefById(state.currentPartRefId, state.template)
        const resources = getUserImageResourcesByPartRef(partRef, state)

        if (resources.length == 1) {
            dispatch({
                type: ACTIONS.SET_CURRENT_RESOURCE,
                id: resources[0].fullId
            })
            changeMenu('image')
        } else {
            changeMenu('select-image')
        }
    }

    const onSelectText = () => {
        if (textResources.length == 1) {
            dispatch({
                type: ACTIONS.SET_CURRENT_RESOURCE,
                id: textResources[0].fullId
            })
            changeMenu('text')
        } else {
            changeMenu('select-text')
        }
    }

    const handleUserResourceClick = (e, resource) => {
        dispatch({
            type: ACTIONS.SET_CURRENT_RESOURCE,
            id: resource.fullId
        })
    }

    const handleGoBack = (e) => {
        e.stopPropagation();
        if (state.dirty) {
            setShowSaveChangesDialog(true)
        }
        else {
            doGoBack();
        }
    }

    const doGoBack = () => {
        history.goBack()
    }

    return <div className={classes.mainContainer}>
        <AppBar onCancel={handleGoBack}/>

        <TemplateContainer handleUserImageClick={handleUserResourceClick}
                           handleUserStringClick={handleUserResourceClick}
                           dispatch={dispatch}
        />

        <TemplatePageList/>

        <ToolbarContainer>
            <ToolbarContent>
                <BubbleList>
                    <Bubble
                        header={t('Insert image')}
                        content={<Icon>photo_library</Icon>}
                        onClick={onSelectImage}/>
                    {textResources.length > 0 && <Bubble
                        header={t('Insert text')}
                        content={<Icon>text_fields</Icon>}
                        onClick={onSelectText}/>}
                    {state.template.type == 'CALENDAR' &&
                    <Bubble
                        header={t('Change year')}
                        content={state.year}
                        disabled={state.template.supportedYears && state.template.supportedYears.length == 1}
                        onClick={() => changeMenu('year')}/>}
                    <Bubble
                        header={t('Preview')}
                        content={<Icon>preview</Icon>}
                        onClick={() => {
                            setPreviewMode(true)
                        }}/>
                </BubbleList>
            </ToolbarContent>
            <ActionsContainer>
                <Button color="primary" onClick={handleGoBack}><Trans>Cancel</Trans></Button>
                {mode == 'update' && <Button color="primary" onClick={handleUpdateCart} disabled={!isComplete}><Trans>Update
                    cart</Trans></Button>}
                {mode != 'update' &&
                <Button color="primary" onClick={addToCart} disabled={!isComplete}><Trans>Add to cart</Trans></Button>}
            </ActionsContainer>
        </ToolbarContainer>
        <ExitDialog open={showSaveChangesDialog}
                    handleCancel={() => setShowSaveChangesDialog(false)}
                    handleOk={doGoBack} />
        {previewMode && <PreviewDialog templateInstance={state}
                                       onClose={() => setPreviewMode(false)}
                        />}
    </div>
}

export default MainPage;